import React from 'react'
import type { TeamStanding } from '../../Api'
import { StandingsTableCon } from './styles'
import { StandingsTableRows } from './StandingsTableRows'
import { shouldShowTies } from '../../Utils'
import { TableHeader } from '../Tables/TableHeader'

type HeaderProps = {
  items: TeamStanding[]
  conference?: string
  section?: string
  theme?: 'light' | 'dark'
  wideFirstCol?: boolean
}

export const StandingsTable: React.FC<React.PropsWithChildren<HeaderProps>> = ({
  items,
  conference,
  section = 'standings',
  theme = 'light',
  wideFirstCol = false,
}) => {
  const showTies = shouldShowTies(items)

  return (
    <StandingsTableCon uiTheme={theme} wideFirstCol={wideFirstCol}>
      <thead>
        <tr>
          <TableHeader ariaLabel={conference || 'Team'}>{conference || 'Team'}</TableHeader>
          <TableHeader ariaLabel="Wins">W</TableHeader>
          <TableHeader ariaLabel="Losses">L</TableHeader>
          {showTies && <TableHeader ariaLabel="Ties">T</TableHeader>}
          <TableHeader ariaLabel="Points">S</TableHeader>
          <TableHeader ariaLabel="Points Against">SA</TableHeader>
          <TableHeader ariaLabel="Point Differential">SD</TableHeader>
        </tr>
      </thead>
      <tbody>
        <StandingsTableRows items={items} section={section} showTies={showTies} />
      </tbody>
    </StandingsTableCon>
  )
}
